var Geometry = require("./complexGeometry.js");

/**
 * Ellipse class, center assumed to be 0,0 always here
 * @param {number} a - major axis length / 2
 * @param {number} b - minor axis length / 2
 * @param {number} angle - angle of ellipse in degrees
 * @param {number} f - distance from center to focus along major axis
 *      in pos x direction when major axis is along x axis
 */
Geometry.Ellipse = function(a, b, angle) {
    this.a = a;
    this.b = b;
    if(Math.abs(angle) < 1e-6) {
        this.angle = 0;
    } else {
        this.angle = angle;
    }
};

Geometry.Ellipse.prototype.copy = function() {
    return new Geometry.Ellipse(this.a, this.b, this.angle);
};

Geometry.Ellipse.prototype.eq = function(e2) {
    return (this.a == e2.a && this.b == e2.b && this.angle == e2.angle);
};

Geometry.Ellipse.prototype.toString = function() {
    return '{'+this.a+','+this.b+','+this.angle+'}';
};

Geometry.Ellipse.posAngle = function (a) {
    return (a+360)%360;
};


/**
 * Scale a general ellipse in x or y
 * @author E.Pataky
 * @function scale
 * @param wScale - width scale factor
 * @param hScale - height scale factor
 */
Geometry.Ellipse.prototype.scale = function(wScale, hScale) {

    if(wScale == 1.0 && hScale == 1.0) { // nothing to do, but ok
        //console.warn("EllipseData scale function scale parameters both 1.0");
        return;
    }

    // radians in radians out
    function acot(x) {
        if(x < 0) {
            return -(Math.PI/2.0) - Math.atan(x);
        } else {
            return (Math.PI/2.0) - Math.atan(x);
        }
    }

    // copy array with optional skip parameters, use -1 for no skipping
    function arrCopy(inArray, skipRow, skipCol) {
        var newArr = [];
        for(var i = 0; i < inArray.length; i++) {
            if(i != skipRow) {
                var row = [];
                for(var j = 0; j < inArray[i].length; j++) {
                    if(j != skipCol) {
                        row.push(inArray[i][j]);
                    }
                }
                newArr.push(row);
                row = null;
            }
        }
        return newArr;
    }

    function determinant(A) {
        var s;
        var det = 0;
        if (A.length == 1) { //bottom case of the recursive function
            return A[0][0];
        }
        if (A.length == 2) {
            det =  A[0][0] * A[1][1] - A[1][0] * A [0][1];
            return det;
        }
        for (var i = 0; i < A.length; i++) {
            //creates smaller matrix- values not in same row, column
            var smaller = new Array(A.length - 1);
            for (var h = 0; h < smaller.length; h++) {
                smaller[h] = new Array(A.length - 1);
            }
            for (var a = 1; a < A.length; a++) {
                for (var b = 0; b < A.length; b++) {
                    if (b < i) {
                        smaller[a - 1][b] = A[a][b];
                    } else if (b > i) {
                        smaller[a - 1][b - 1] = A[a][b];
                    }
                }
            }
            if (i % 2 == 0) {
                s = 1;
            } else {
                s = -1;
            }
            det += s * A[0][i] * (determinant(smaller));
        }
        return (det);
    }

    var ia = this.angle;
    var iaPos = Geometry.Ellipse.posAngle(ia);
    var _pi_180 = Math.PI/180.0;
    var _180_pi = 180.0/Math.PI;

    // scale the points, note that w and h points would scale to be valid points,
    // but different points than they were on the ellipse .. but the center will actually
    // scale and still be the center
    var ratio = 1.0;
    var widthScaling = wScale != 1.0;
    if (widthScaling) {
        ratio = wScale;
    } else { // then assume hScale != 1.0
        ratio = hScale;
    }

    var a = this.a, b = this.b;
    if($.inArray(iaPos, [0.0, 90.0, 180.0, 270.0]) != -1) {
        // simple scaling without angles
        if(iaPos == 0 || iaPos == 180) {
            var newA = (widthScaling ? a*ratio : a);
            var newB = (widthScaling ? b : b*ratio);
            if((newA - newB) > 0) { a = newA; b = newB; }
            else { a = newB; b = newA; ia -= 90.0; }
        } else if(iaPos == 90 || iaPos == 270) {
            var newA = (widthScaling ? a : a*ratio);
            var newB = (widthScaling ? b*ratio : b);
            if((newA - newB) > 0) { a = newA; b = newB; }
            else { a = newB; b = newA; ia -= 90.0; }
        }
    } else {
        // get some points on the ellipse
        // x(t) = h + a*cos(t)*cos(phi) - b*sin(t)*sin(phi)
        // y(t) = k + b*sin(t)*cos(phi) + a*cos(t)*sin(phi)
        var sina = Math.sin(ia*_pi_180);
        var cosa = Math.cos(ia*_pi_180);
        var points = [];
        for(var t = 0; t < 360; t += 60) {
            var tRad = parseFloat(t)*_pi_180;
            var cos_t = Math.cos(tRad);
            var sin_t = Math.sin(tRad);
            points.push(new Geometry.Coord(
                0 + a*cos_t*cosa - b*sin_t*sina,
                0 + b*sin_t*cosa + a*cos_t*sina
            ));
            tRad = cos_t = sin_t = null;
        }
        sina = cosa = null;

        // now scale these points on this imaginary ellipse centered at zero
        for(var ind1 = 0; ind1 < points.length; ind1++) {
            if (widthScaling) {
                points[ind1].x *= ratio;
            } else {
                points[ind1].y *= ratio;
            }
        }

        // we now have points after scaling, find ellipse
        // https://en.wikipedia.org/wiki/Ellipse#General_parametric_form
        // http://math.stackexchange.com/questions/632442/calculate-ellipse-from-points
        // http://mathworld.wolfram.com/Ellipse.html
        // http://math.stackexchange.com/questions/616645/determining-the-major-minor-axes-of-an-ellipse-from-general-form/820896#820896
        // http://math.stackexchange.com/questions/280937/finding-the-angle-of-rotation-of-an-ellipse-from-its-general-equation-and-the-ot
        // http://www.had2know.com/academics/conic-section-through-five-points.html
        // http://stackoverflow.com/questions/87734/how-do-you-calculate-the-axis-aligned-bounding-box-of-an-ellipse
        // http://www.had2know.com/academics/conic-section-through-five-points.html
        // http://www.lee-mac.com/5pointellipse.html
        /**
         ellipse: Ax^2 + Cy^2 + Bxy + Dx + Ey + F = 0
         matrix for 5 points:  5x6 X 6x1 = 5x1

         (below represents matrices)
         |x^2  y^2  xy   x  y  1|   |A|   |0|
         |x1^2 y1^2 x1y1 x1 y1 1|   |C|   |0|
         |x2^2 y2^2 x2y2 x2 y2 1| * |B| = |0|
         |x3^2 y3^2 x3y3 x3 y3 1|   |D|   |0|
         |x4^2 y4^2 x4y4 x4 y4 1|   |E|   |0|
         |x5^2 y5^2 x5y5 x5 y5 1|   |F|   |0|

         (below represents determinant)
         |x^2  y^2  xy   x  y  1|
         |x1^2 y1^2 x1y1 x1 y1 1|
         |x2^2 y2^2 x2y2 x2 y2 1|  = 0
         |x3^2 y3^2 x3y3 x3 y3 1|
         |x4^2 y4^2 x4y4 x4 y4 1|
         |x5^2 y5^2 x5y5 x5 y5 1|

         A = det(A_a), B = -det(A_b), ...
         where A_a is A with the first row and 1st col removed
         where A_b is A with the first row and 2nd col removed
         ... etc
         */
        var matrixA = [];
        for(var ind2 = 0; ind2 < points.length; ind2++) {
            var x = points[ind2].x;
            var y = points[ind2].y;
            matrixA.push([x*x, y*y, x*y, x, y, 1.0]);
        }

        // make copies and use skipRow and skipCol
        var matrixAa = arrCopy(matrixA, 0, 0);
        var matrixAc = arrCopy(matrixA, 0, 1);
        var matrixAb = arrCopy(matrixA, 0, 2);
        var matrixAd = arrCopy(matrixA, 0, 3);
        var matrixAe = arrCopy(matrixA, 0, 4);
        var matrixAf = arrCopy(matrixA, 0, 5);

        // solve for variables
        var A = determinant(matrixAa);
        var C = -determinant(matrixAc);
        var B = determinant(matrixAb);
        var D = -determinant(matrixAd);
        var E = determinant(matrixAe);
        var F = -determinant(matrixAf);

        // Ax^2 + Cy^2 + Bxy + Dx + Ey + F = 0
        /* helpful in debugging should always get close to zero error
         var errorSum = 0;
         for(var ind3 = 0; ind3 < points.length; ind3++) {
         var x = points[ind3].x;
         var y = points[ind3].y;
         var test = A*x*x + C*y*y + B*x*y + D*x + E*y + F;
         errorSum += test;
         }
         console.log("errorSum=" + errorSum);*/

        // get a and b
        var B2 = B*B;
        var b24ac = (B2 - 4*A*C);
        var val1 = -Math.sqrt(2*(A*E*E + C*D*D - B*D*E + b24ac*F)*
                (A+C + Math.sqrt((A-C)*(A-C) + B2))) / b24ac;
        var val2 = -Math.sqrt(2*(A*E*E + C*D*D - B*D*E + b24ac*F)*
                (A+C - Math.sqrt((A-C)*(A-C) + B2))) / b24ac;
        B2 = b24ac = null;

        if(val1 > val2) {
            a = val1;
            b = val2;
        } else {
            a = val2;
            b = val1;
        }

        // now we have all the parameters of the scaled ellipse, find the ellipse properties
        // http://mathworld.wolfram.com/Ellipse.html
        // note there is a conversion in variables here to math wolfram while the main
        // equation used was from wikipedia
        if(B == 0 && A < C) {
            ia = 0;
        } else if(B == 0 && A > C) {
            ia = 90;
        } else if(A < C) {
            ia = 0.5*acot((A-C)/(B))*_180_pi;
        } else if(A > C) {
            ia = 90.0 + 0.5*acot((A-C)/(B))*_180_pi;
        }

        var oldQuadrant = parseInt(Geometry.Ellipse.posAngle(this.angle + 0.01) / 90) + 1;
        var newQuadrant = parseInt(Geometry.Ellipse.posAngle(ia + 0.01) / 90) + 1;
        if(oldQuadrant != newQuadrant) {
            ia = ia - (newQuadrant-oldQuadrant)*90.0;
        }

        A = B = C = D = E = F = null;
        matrixA = points = null;
        matrixAa = matrixAb = matrixAc = matrixAd = matrixAe = matrixAf = null;
    }


    if(!isNaN(a) && !isNaN(b)) {
        this.a = a;
        this.b = b;

        // make positive
        ia = Geometry.Ellipse.posAngle(ia);

        this.angle = ia;
    } else {
        console.warn("Geometry Ellipse scale function invalid a or b")
    }

    ia = widthScaling = ratio = null;
    _pi_180 = _180_pi = null;
};
